import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('ALBUM_MEDIA').plugin(axiosPlugin);

let createAlbumMediaAction = redux.fetchActionCreate();

export const TYPES = redux.types;

export const createAlbumMedia = (albumId, data = {}) => createAlbumMediaAction(`/albums/${albumId}/medias`, data);

export const albumMedia = redux.reducer();



